module.exports = __webpack_public_path__ + "static/media/slide (8).d10e878a.jpg";